<template>
  <div class="a">
    <Nav/>
    <PageBannerBig :banner="banner"></PageBannerBig>
    <AfSolutionDetails/>

    <Contact/>
    <Footer/>
  </div>
</template>

<script>
import Nav from '@/components/Nav'
import PageBannerBig from '@/components/PageBannerBig'
import AfSolutionDetails from '@/components/AfSolutionDetails'
import Contact from '@/components/Contact'
import Footer from '@/components/Footer'
export default {
  name: '',
  components: {
    Nav,
    PageBannerBig,
    AfSolutionDetails,
    Contact,
    Footer
  },
  data () {
    return {
      banner: {
        img: require("@/assets/img/af-solution-banner.png"),
        title: "汽车金融",
        sub: "汽车金融公司成为了汽车公司利润来源的一块宝藏"
      }
    }
  }
}
</script>

<style scoped lang="less">
.a{
  .b{
    font-size: 30px;
  }
}
</style>